import { h } from "omi";

import {
  PortfolioDeleteModalData as IPortfolioDeleteModalData,
  PortfolioDeleteModal as PortfolioDeleteModalPage,
} from "@/pages/portfolio/ui/modals/deleteProjectModal";
import {
  PortfolioEditModalData as IPortfolioEditModalData,
  PortfolioUploadModalData as IPortfolioUploadModalData,
  PortfolioUploadModal as PortfolioUploadModalPage,
} from "@/pages/portfolio/ui/modals/uploadProjectModal";

import { ModalProps } from "../../models";

export type PortfolioUploadModalData = IPortfolioUploadModalData;
export const PortfolioUploadModal = (props: ModalProps<IPortfolioUploadModalData>) => {
  return <PortfolioUploadModalPage {...props}></PortfolioUploadModalPage>;
};

export type PortfolioEditModalData = IPortfolioEditModalData;
export const PortfolioEditModal = (props: ModalProps<IPortfolioEditModalData>) => {
  return <PortfolioUploadModalPage {...props}></PortfolioUploadModalPage>;
};

export type PortfolioDeleteModalData = IPortfolioDeleteModalData;
export const PortfolioDeleteModal = (props: ModalProps<IPortfolioDeleteModalData>) => {
  return <PortfolioDeleteModalPage {...props}></PortfolioDeleteModalPage>;
};
